import { render, staticRenderFns } from "./userroledetails.vue?vue&type=template&id=481497f2&"
import script from "./userroledetails.vue?vue&type=script&lang=js&"
export * from "./userroledetails.vue?vue&type=script&lang=js&"
import style0 from "./userroledetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports